import React from "react";
import { Box, Grid, Stack } from "@mui/material";
import VSNToolTip from "../../../shared/VSNToolTip";
import VSNTypography from "../../../shared/VSNTypography";
import { upperCase } from "../../../utils/javascript";
import useOTBStyle from "../OTBStyle";
import {
  CompositionIcon1,
  CompositionIcon2,
  CompositionIcon3,
} from "../../../shared/icon";
import vasanaOrignalLogo from "../../../assets/common/svg/vasanaOrignalLogo.svg";
import sa from "../../../assets/landing/svg/sa.svg";
import ga from "../../../assets/quickView/svg/ga.svg";
import re from "../../../assets/quickView/svg/re.svg";
import ma from "../../../assets/quickView/svg/ma.svg";
import VSNImage from "../../../shared/VSNImage";

const VasanaTypeComposition = ({ data, pdf }) => {
  const classes = useOTBStyle();

  const defaultVasanaTypes = [
    { name: "Sa", value: 0, users: [], index: 4 },
    { name: "Re", value: 0, users: [], index: 1 },
    { name: "Ga", value: 0, users: [], index: 2 },
    { name: "Ma", value: 0, users: [], index: 3 },
  ];

  const groupBy = (key) =>
    data?.reduce((acc, item) => {
      const value = item[key];
      acc[value] = acc[value] || [];
      acc[value].push(item);
      return acc;
    }, {});

  const groupedData = groupBy("vasana_type") || {};

  const VasanaType = defaultVasanaTypes?.map((defaultType) => {
    const matchedType = groupedData[defaultType.name] || [];
    return {
      ...defaultType,
      value: matchedType.length,
      users: matchedType,
    };
  });

  // const VasanaType = Object.entries(groupBy("vasana_type") || {})?.map(
  //   ([key, items]) => ({
  //     name: key,
  //     value: items.length || 0,
  //     users: items,
  //     index:
  //       key === "Sa"
  //         ? 4
  //         : key === "Re"
  //         ? 1
  //         : key === "Ga"
  //         ? 2
  //         : key === "Ma"
  //         ? 3
  //         : 0,
  //   })
  // );

  const sortedVasanaType = VasanaType.sort((a, b) => a.index - b.index);

  const calculateDotPosition = (totalUsersInCategory, index) => {
    const angle = (index / totalUsersInCategory) * 360;
    const radius = 50;
    const x = Math.cos((angle * Math.PI) / Math.random(0, 180)) * radius;
    const y = Math.sin((angle * Math.PI) / Math.random(0, 180)) * radius;
    return { x, y };
  };

  const renderDataItems = (dataItems, category) => {
    return dataItems?.map((item, index) => {
      const { x, y } = calculateDotPosition(dataItems.length, index);

      return (
        <VSNToolTip
          key={`${category}-${item.patient_id}`}
          title={
            <Stack direction="row" alignItems="center" spacing={1}>
              <VSNTypography color="var(--blackGray)">
                {item.patient_name}
              </VSNTypography>
            </Stack>
          }
          placement="top"
          arrow
          slotProps={{
            popper: {
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: "var(--white)",
                  boxShadow: "0px 6.447px 8px 0px rgba(0, 0, 0, 0.10)",
                  color: "var(--blackGray)",
                  py: 1,
                  px: 1.5,
                  borderRadius: 3,
                  "& .MuiTooltip-arrow": {
                    color: "var(--blackGray)",
                  },
                },
              },
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              transform: "translate(-50%, -50%)",
              left: `calc(50% + ${x}px)`,
              top: `calc(50% + ${y}px)`,
              width: "4px",
              height: "4px",
              backgroundColor: "#1F396D",
              borderRadius: "50%",
            }}
          />
        </VSNToolTip>
      );
    });
  };

  return (
    <Box>
      {pdf && (
        <Box
          className={classes.pdfReportLayout}
          sx={{
            pageBreakAfter: "always",
            marginTop: "20px",
          }}
        >
          <VSNTypography variant="h4">
            Vasana Type Team Composition
          </VSNTypography>

          <Stack direction="row" gap={2} alignItems="center">
            <Stack width="100%">
              <Stack gap={3}>
                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                    width: "100%",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="16px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={ma} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Emphasize the Big Picture
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        While discussing projects, emphasize the broader vision
                        or end goal to engage Ma types.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Have Data-Informed Discussions
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Present your ideas with supporting data and evidence to
                        resonate with their preference for detailed information.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Be Patient and Detail Oriented
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Practice patience and appreciate their need for
                        thoroughness. Offer concise and relevant data to aid
                        decision-making.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                    width: "100%",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="16px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={ga} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Align Priorities
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Recognize the value in others ideas. Instead of
                        competing, collaborate to merge the best aspects of both
                        strategies.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Introduce Change Gradually
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        If reporting to another Control, respect their
                        leadership. Offer constructive feedback instead of
                        undermining efforts.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Be Flexible in Approach
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Explore opportunities for shared leadership or
                        decision-making, especially in projects involving
                        multiple Controls.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>

            <Stack width="100%">
              <Box className={classes.donutContainer}>
                <Box className={classes.donut} style={{ position: "relative" }}>
                  {sortedVasanaType?.map((item, index) => {
                    const categoryData = item.users || [];
                    return (
                      <Box key={index + 1}>
                        <div
                          className={`${classes.segment} ${
                            classes[`segment${index + 1}`]
                          } `}
                        >
                          <div className={classes.dot}>
                            <span className={classes[`label${index + 1}`]}>
                              {upperCase(item.name) || 0} ({item.value})
                            </span>
                            <div className={classes.dotWrapper}>
                              {renderDataItems(categoryData, item.name)}
                            </div>
                          </div>
                        </div>
                      </Box>
                    );
                  })}
                  <div className={classes.circle}>
                    <span>
                      <VSNImage src={vasanaOrignalLogo} />
                    </span>
                  </div>
                </Box>
              </Box>
            </Stack>

            <Stack width="100%">
              <Stack gap={3}>
                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="16px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={sa} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Embrace Collaboration
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        {`Recognize the value in others' ideas. Instead of competing, collaborate to merge the best aspects of both strategies.`}
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Respect Authority
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        If reporting to another Control, respect their
                        leadership. Offer constructive feedback instead of
                        undermining efforts.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Share Leadership
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Explore opportunities for shared leadership or
                        decision-making, especially in projects involving
                        multiple Controls.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="16px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={re} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Balance Action with Strategy
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Combine quick action and strategic planning. Offer to
                        help in evaluating strategies before execution.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Build Trust
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Work on building trust with Re types by acknowledging
                        the strengths of their proactive approach while gently
                        guiding them towards a more measured strategy.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontSize="12px" fontWeight={600}>
                        Be Adaptable
                      </VSNTypography>
                      <VSNTypography
                        fontSize="12px"
                        fontWeight={400}
                        color="#7A7A85"
                      >
                        Be open to occasionally moving at a faster pace and
                        appreciate the dynamism of the Re type.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Box>
      )}

      {!pdf && (
        <Box className={classes.reportLayout}>
          <div className={classes.stickyTitle}>
            <VSNTypography variant="h2">
              Vasana Type Team Composition
            </VSNTypography>
          </div>

          <Grid container alignItems="center">
            <Grid item xs={12} xl={4}>
              <Stack gap={3}>
                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="18px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={ma} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Emphasize the Big Picture
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        While discussing projects, emphasize the broader vision
                        or end goal to engage Ma types.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Have Data-Informed Discussions
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Present your ideas with supporting data and evidence to
                        resonate with their preference for detailed information.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Be Patient and Detail Oriented
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Practice patience and appreciate their need for
                        thoroughness. Offer concise and relevant data to aid
                        decision-making.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="18px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={ga} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Align Priorities
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Recognize the value in others ideas. Instead of
                        competing, collaborate to merge the best aspects of both
                        strategies.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Introduce Change Gradually
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        If reporting to another Control, respect their
                        leadership. Offer constructive feedback instead of
                        undermining efforts.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Be Flexible in Approach
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Explore opportunities for shared leadership or
                        decision-making, especially in projects involving
                        multiple Controls.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </Grid>

            <Grid item xs={12} xl={4}>
              <Box className={classes.donutContainer}>
                <Box className={classes.donut} style={{ position: "relative" }}>
                  {sortedVasanaType?.map((item, index) => {
                    const categoryData = item.users || [];

                    return (
                      <Box key={index + 1}>
                        <div
                          className={`${classes.segment} ${
                            classes[`segment${index + 1}`]
                          } `}
                        >
                          <div className={classes.dot}>
                            <span className={classes[`label${index + 1}`]}>
                              {upperCase(item.name)} ({item.value})
                            </span>
                            <div className={classes.dotWrapper}>
                              {renderDataItems(categoryData, item.name)}
                            </div>
                          </div>
                        </div>
                      </Box>
                    );
                  })}
                  <div className={classes.circle}>
                    <span>
                      <VSNImage src={vasanaOrignalLogo} alt="vasanaLogo" />
                    </span>
                  </div>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} xl={4}>
              <Stack gap={3}>
                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="18px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={sa} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Embrace Collaboration
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        {`Recognize the value in others' ideas. Instead of competing, collaborate to merge the best aspects of both strategies.`}
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Respect Authority
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        If reporting to another Control, respect their
                        leadership. Offer constructive feedback instead of
                        undermining efforts.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Share Leadership
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Explore opportunities for shared leadership or
                        decision-making, especially in projects involving
                        multiple Controls.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "#FAF8F5",
                    padding: 2,
                    border: "1px solid #C3A577",
                    borderRadius: "12px",
                  }}
                  gap={1}
                >
                  <Stack direction="row" spacing={1}>
                    <VSNTypography fontSize="18px" fontWeight={700}>
                      Understanding Vasana Type
                    </VSNTypography>
                    <VSNImage src={re} at="type" />
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon1 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Balance Action with Strategy
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Combine quick action and strategic planning. Offer to
                        help in evaluating strategies before execution.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon2 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Build Trust
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Work on building trust with Re types by acknowledging
                        the strengths of their proactive approach while gently
                        guiding them towards a more measured strategy.
                      </VSNTypography>
                    </Box>
                  </Stack>
                  <Stack direction="row">
                    <Box mr={1} mt={0.3}>
                      <CompositionIcon3 />
                    </Box>
                    <Box>
                      <VSNTypography fontWeight={600}>
                        Be Adaptable
                      </VSNTypography>
                      <VSNTypography fontWeight={400} color="#7A7A85">
                        Be open to occasionally moving at a faster pace and
                        appreciate the dynamism of the Re type.
                      </VSNTypography>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default VasanaTypeComposition;
